module.exports = __webpack_public_path__ + "static/img/404.f53c1af.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/404.gif
// module id = 684
// module chunks = 3